// extracted by mini-css-extract-plugin
export var screen1 = "screen1-module--screen1--d2167";
export var screen1__link = "screen1-module--screen1__link--4474f";
export var screen1__linkWrapper = "screen1-module--screen1__link-wrapper--a6c21";
export var screen1__subtitle = "screen1-module--screen1__subtitle--0db0a";
export var screen1__title = "screen1-module--screen1__title--9793f";
export var screen1__titleWrapper = "screen1-module--screen1__title-wrapper--27775";
export var screen1__wrapper = "screen1-module--screen1__wrapper--84e22";